import React from 'react';

import './styles/index.scss';

export type TIconType =
  | 'menu-vertical'
  | 'close'
  | 'open'
  | 'directions'
  | 'fit'
  | 'plus'
  | 'minus'
  | 'code'
  | 'zoom-out'
  | 'qr-code'
  | 'info'
  | 'drag-indicator'
  | 'help';

const showIcon = (icon: TIconType) => {
  switch (icon) {
    case 'menu-vertical':
      return <path d="M6 42V39H42V42ZM6 25.5V22.5H42V25.5ZM6 9V6H42V9Z" />;
    case 'open':
      return (
        <path d="M9 42Q7.8 42 6.9 41.1Q6 40.2 6 39V9Q6 7.8 6.9 6.9Q7.8 6 9 6H22.95V9H9Q9 9 9 9Q9 9 9 9V39Q9 39 9 39Q9 39 9 39H39Q39 39 39 39Q39 39 39 39V25.05H42V39Q42 40.2 41.1 41.1Q40.2 42 39 42ZM19.1 31.05 17 28.9 36.9 9H25.95V6H42V22.05H39V11.15Z" />
      );
    case 'close':
      return (
        <path d="M12.45 37.65 10.35 35.55 21.9 24 10.35 12.45 12.45 10.35 24 21.9 35.55 10.35 37.65 12.45 26.1 24 37.65 35.55 35.55 37.65 24 26.1Z" />
      );
    case 'directions':
      return (
        <path d="M21.85 43.35 4.65 26.15Q3.85 25.35 3.85 24Q3.85 22.65 4.65 21.85L21.85 4.65Q22.65 3.85 24 3.85Q25.35 3.85 26.15 4.65L43.35 21.85Q44.15 22.65 44.15 24Q44.15 25.35 43.35 26.15L26.15 43.35Q25.35 44.15 24 44.15Q22.65 44.15 21.85 43.35ZM24 41.2Q24 41.2 24 41.2Q24 41.2 24 41.2L41.2 24Q41.2 24 41.2 24Q41.2 24 41.2 24L24 6.8Q24 6.8 24 6.8Q24 6.8 24 6.8L6.8 24Q6.8 24 6.8 24Q6.8 24 6.8 24ZM24 33.85 33.85 24 24 14.15 21.85 16.3 28.05 22.5H14.15V25.5H28.05L21.85 31.7ZM24 24Q24 24 24 24Q24 24 24 24Q24 24 24 24Q24 24 24 24Q24 24 24 24Q24 24 24 24Q24 24 24 24Q24 24 24 24Z" />
      );
    case 'fit':
      return (
        <path d="M41 17.5V11Q41 11 41 11Q41 11 41 11H34.5V8H41Q42.2 8 43.1 8.9Q44 9.8 44 11V17.5ZM4 17.5V11Q4 9.8 4.9 8.9Q5.8 8 7 8H13.5V11H7Q7 11 7 11Q7 11 7 11V17.5ZM34.5 40V37H41Q41 37 41 37Q41 37 41 37V30.5H44V37Q44 38.2 43.1 39.1Q42.2 40 41 40ZM7 40Q5.8 40 4.9 39.1Q4 38.2 4 37V30.5H7V37Q7 37 7 37Q7 37 7 37H13.5V40ZM10 34V14H38V34ZM13 31H35V17H13ZM13 31V17V31Z" />
      );
    case 'zoom-out':
      return (
        <path d="M6 42V30.5H9V36.85L16.4 29.45L18.55 31.6L11.15 39H17.5V42ZM30.5 42V39H36.85L29.5 31.65L31.65 29.5L39 36.85V30.5H42V42ZM16.35 18.5 9 11.15V17.5H6V6H17.5V9H11.15L18.5 16.35ZM31.65 18.5 29.5 16.35 36.85 9H30.5V6H42V17.5H39V11.15Z" />
      );
    case 'qr-code':
      return (
        <path d="M26 42V38H30V42ZM22 38V28H26V38ZM38 32V24H42V32ZM34 24V20H38V24ZM10 28V24H14V28ZM6 24V20H10V24ZM24 10V6H28V10ZM8.5 15.5H15.5V8.5H8.5ZM6 18V6H18V18ZM8.5 39.5H15.5V32.5H8.5ZM6 42V30H18V42ZM32.5 15.5H39.5V8.5H32.5ZM30 18V6H42V18ZM34 42V36H30V32H38V38H42V42ZM26 28V24H34V28ZM18 28V24H14V20H26V24H22V28ZM20 18V10H24V14H28V18ZM10.5 13.5V10.5H13.5V13.5ZM10.5 37.5V34.5H13.5V37.5ZM34.5 13.5V10.5H37.5V13.5Z" />
      );
    case 'plus':
      return (
        <path d="M22.5 38V25.5H10V22.5H22.5V10H25.5V22.5H38V25.5H25.5V38Z" />
      );
    case 'minus':
      return <path d="M10 25.5V22.5H38V25.5Z" />;
    case 'code':
      return (
        <path d="M7 40Q5.8 40 4.9 39.1Q4 38.2 4 37V11Q4 9.8 4.9 8.9Q5.8 8 7 8H41Q42.2 8 43.1 8.9Q44 9.8 44 11V37Q44 38.2 43.1 39.1Q42.2 40 41 40ZM12.35 30.3H14.45V17.7H12.85L9.2 20.15L10.25 21.8L12.35 20.4ZM19 30.3H27.15V28.4H21.7V28.3Q22.4 27.7 23.225 26.975Q24.05 26.25 24.7 25.6Q25.75 24.6 26.35 23.675Q26.95 22.75 26.95 21.45Q26.95 19.85 25.85 18.775Q24.75 17.7 23 17.7Q21.5 17.7 20.475 18.4Q19.45 19.1 18.95 20.25L20.85 21.15Q21.1 20.6 21.7 20.2Q22.3 19.8 23 19.8Q23.9 19.8 24.4 20.3Q24.9 20.8 24.9 21.5Q24.9 22.5 24.4 23.175Q23.9 23.85 23.05 24.6Q21.9 25.65 21.025 26.45Q20.15 27.25 19 28.35ZM34.7 30.3Q36.5 30.3 37.675 29.425Q38.85 28.55 38.85 26.7Q38.85 25.45 38.2 24.65Q37.55 23.85 36.5 23.75V23.7Q37.45 23.4 37.925 22.725Q38.4 22.05 38.4 20.95Q38.4 19.45 37.325 18.575Q36.25 17.7 34.65 17.7Q33.55 17.7 32.55 18.3Q31.55 18.9 30.9 20.05L32.6 20.95Q33 20.4 33.525 20.075Q34.05 19.75 34.65 19.75Q35.4 19.75 35.875 20.175Q36.35 20.6 36.35 21.35Q36.35 22.2 35.775 22.5Q35.2 22.8 34.25 22.8H33.55V24.75H34.3Q35.25 24.75 36.025 25.25Q36.8 25.75 36.8 26.7Q36.8 27.6 36.225 28.075Q35.65 28.55 34.7 28.55Q33.95 28.55 33.25 28.05Q32.55 27.55 32.25 26.7L30.5 27.35Q30.9 28.7 31.925 29.5Q32.95 30.3 34.7 30.3ZM7 37H41Q41 37 41 37Q41 37 41 37V11Q41 11 41 11Q41 11 41 11H7Q7 11 7 11Q7 11 7 11V37Q7 37 7 37Q7 37 7 37ZM7 37Q7 37 7 37Q7 37 7 37V11Q7 11 7 11Q7 11 7 11Q7 11 7 11Q7 11 7 11V37Q7 37 7 37Q7 37 7 37Z" />
      );
    case 'info':
      return (
        <path d="M22.65 34H25.65V22H22.65ZM24 18.3Q24.7 18.3 25.175 17.85Q25.65 17.4 25.65 16.7Q25.65 16 25.175 15.5Q24.7 15 24 15Q23.3 15 22.825 15.5Q22.35 16 22.35 16.7Q22.35 17.4 22.825 17.85Q23.3 18.3 24 18.3ZM24 44Q19.75 44 16.1 42.475Q12.45 40.95 9.75 38.25Q7.05 35.55 5.525 31.9Q4 28.25 4 24Q4 19.8 5.525 16.15Q7.05 12.5 9.75 9.8Q12.45 7.1 16.1 5.55Q19.75 4 24 4Q28.2 4 31.85 5.55Q35.5 7.1 38.2 9.8Q40.9 12.5 42.45 16.15Q44 19.8 44 24Q44 28.25 42.45 31.9Q40.9 35.55 38.2 38.25Q35.5 40.95 31.85 42.475Q28.2 44 24 44ZM24 24Q24 24 24 24Q24 24 24 24Q24 24 24 24Q24 24 24 24Q24 24 24 24Q24 24 24 24Q24 24 24 24Q24 24 24 24ZM24 41Q31 41 36 36Q41 31 41 24Q41 17 36 12Q31 7 24 7Q17 7 12 12Q7 17 7 24Q7 31 12 36Q17 41 24 41Z" />
      );
    case 'help':
      return (
        <path d="M24.2 35.65Q25 35.65 25.55 35.1Q26.1 34.55 26.1 33.75Q26.1 32.95 25.55 32.4Q25 31.85 24.2 31.85Q23.4 31.85 22.85 32.4Q22.3 32.95 22.3 33.75Q22.3 34.55 22.85 35.1Q23.4 35.65 24.2 35.65ZM22.45 28.35H25.4Q25.4 27.05 25.725 25.975Q26.05 24.9 27.75 23.5Q29.3 22.2 29.95 20.95Q30.6 19.7 30.6 18.2Q30.6 15.55 28.875 13.95Q27.15 12.35 24.3 12.35Q21.85 12.35 19.975 13.575Q18.1 14.8 17.25 16.95L19.9 17.95Q20.45 16.55 21.55 15.775Q22.65 15 24.15 15Q25.85 15 26.9 15.925Q27.95 16.85 27.95 18.3Q27.95 19.4 27.3 20.375Q26.65 21.35 25.4 22.4Q23.9 23.7 23.175 24.975Q22.45 26.25 22.45 28.35ZM24 44Q19.8 44 16.15 42.475Q12.5 40.95 9.8 38.25Q7.1 35.55 5.55 31.9Q4 28.25 4 24Q4 19.8 5.55 16.15Q7.1 12.5 9.8 9.8Q12.5 7.1 16.15 5.55Q19.8 4 24 4Q28.15 4 31.8 5.55Q35.45 7.1 38.15 9.8Q40.85 12.5 42.425 16.15Q44 19.8 44 24Q44 28.25 42.425 31.9Q40.85 35.55 38.15 38.25Q35.45 40.95 31.8 42.475Q28.15 44 24 44ZM24 23.45Q24 23.45 24 23.45Q24 23.45 24 23.45Q24 23.45 24 23.45Q24 23.45 24 23.45Q24 23.45 24 23.45Q24 23.45 24 23.45Q24 23.45 24 23.45Q24 23.45 24 23.45ZM24 41Q31.05 41 36.025 36Q41 31 41 24Q41 17 36.025 12Q31.05 7 24 7Q16.85 7 11.925 12Q7 17 7 24Q7 31 11.925 36Q16.85 41 24 41Z" />
      );
    case 'drag-indicator':
      return (
        <path
          d="M18,40c-1.1,0-2-0.4-2.8-1.2S14,37.1,14,36c0-1.1,0.4-2,1.2-2.8S16.9,32,18,32s2,0.4,2.8,1.2S22,34.9,22,36
      c0,1.1-0.4,2-1.2,2.8S19.1,40,18,40z M30,40c-1.1,0-2-0.4-2.8-1.2C26.4,38,26,37.1,26,36c0-1.1,0.4-2,1.2-2.8C28,32.4,28.9,32,30,32
      s2,0.4,2.8,1.2C33.6,34,34,34.9,34,36c0,1.1-0.4,2-1.2,2.8C32,39.6,31.1,40,30,40z M18,28c-1.1,0-2-0.4-2.8-1.2S14,25.1,14,24
      s0.4-2,1.2-2.8C16,20.4,16.9,20,18,20s2,0.4,2.8,1.2C21.6,22,22,22.9,22,24s-0.4,2-1.2,2.8S19.1,28,18,28z M30,28
      c-1.1,0-2-0.4-2.8-1.2C26.4,26,26,25.1,26,24s0.4-2,1.2-2.8C28,20.4,28.9,20,30,20s2,0.4,2.8,1.2C33.6,22,34,22.9,34,24
      s-0.4,2-1.2,2.8C32,27.6,31.1,28,30,28z M18,16c-1.1,0-2-0.4-2.8-1.2C14.4,14,14,13.1,14,12s0.4-2,1.2-2.8C16,8.4,16.9,8,18,8
      s2,0.4,2.8,1.2C21.6,10,22,10.9,22,12s-0.4,2-1.2,2.8C20,15.6,19.1,16,18,16z M30,16c-1.1,0-2-0.4-2.8-1.2C26.4,14,26,13.1,26,12
      s0.4-2,1.2-2.8C28,8.4,28.9,8,30,8s2,0.4,2.8,1.2C33.6,10,34,10.9,34,12s-0.4,2-1.2,2.8C32,15.6,31.1,16,30,16z"
        />
      );
    default:
      return (
        <path d="M7 24Q7 27.05 8.1 29.875Q9.2 32.7 11.05 34.95L34.95 11.05Q32.65 9.1 29.85 8.05Q27.05 7 24 7Q16.9 7 11.95 11.95Q7 16.9 7 24ZM13.05 37Q15.3 38.95 18.125 39.975Q20.95 41 24 41Q31.1 41 36.05 36.05Q41 31.1 41 24Q41 20.95 39.95 18.15Q38.9 15.35 37 13.05ZM4 24Q4 19.85 5.575 16.2Q7.15 12.55 9.85 9.85Q12.55 7.15 16.2 5.575Q19.85 4 24 4Q28.15 4 31.8 5.575Q35.45 7.15 38.15 9.85Q40.85 12.55 42.425 16.2Q44 19.85 44 24Q44 28.15 42.425 31.8Q40.85 35.45 38.15 38.15Q35.45 40.85 31.8 42.425Q28.15 44 24 44Q19.85 44 16.2 42.425Q12.55 40.85 9.85 38.15Q7.15 35.45 5.575 31.8Q4 28.15 4 24Z" />
      );
  }
};

export interface Props {
  icon: TIconType;
  title?: string;
  className?: string;
}

const SVGIcon: React.FC<Props> = ({ icon, title, className }: Props) => (
  // With a `title`, expose an accessible name (role=img + aria-label). Without
  // one the icon is decorative — hide it from the a11y tree so screen readers
  // don't announce an unnamed graphic (the surrounding control carries the
  // label instead).
  <svg
    role={title ? 'img' : undefined}
    aria-label={title || undefined}
    aria-hidden={title ? undefined : true}
    className={`SVGIcon${className ? ` ${className}` : ''}`}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    fill="currentColor"
  >
    {title && <title>{title}</title>}
    {showIcon(icon)}
  </svg>
);

export default SVGIcon;
